import {
    FETCH_CALENDAR_APPOINTMENTS_REQUEST,
    FETCH_CALENDAR_APPOINTMENTS_SUCCESS,
    FETCH_CALENDAR_APPOINTMENTS_FAILURE,
  } from "./FetchCalendarAppointmentsTypes";
  import api from "../../utils/Api";
  
  export const fetchCalendarAppointmentsRequest = () => {
    return {
      type: FETCH_CALENDAR_APPOINTMENTS_REQUEST,
    };
  };
  
  export const fetchCalendarAppointmentsSuccess = (calendarAppointments) => {
    return {
      type: FETCH_CALENDAR_APPOINTMENTS_SUCCESS,
      payload: calendarAppointments,
    };
  };
  
  export const fetchCalendarAppointmentsFailure = (error) => {
    return {
      type: FETCH_CALENDAR_APPOINTMENTS_FAILURE,
      payload: error,
    };
  };
  
  export const fetchCalendarAppointments = (bdate) => {
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };
    let url = "/appointment/viewCalendarData/fetch?";

    if(bdate){
        url += "bdate="+ bdate;
    }
    
    return async (dispatch) => {
      dispatch(fetchCalendarAppointmentsRequest());
      try {
        const response = await api.get(url,
          {
            headers: headers,
          }
        );
        const calendarAppointments = response.data.data;
        //console.log("****** calendar response", calendarAppointments);
        dispatch(fetchCalendarAppointmentsSuccess(calendarAppointments));
      } catch (error) {
        console.log("Redux error - ", error.response);
        const errorMsg = error.message;
        dispatch(fetchCalendarAppointmentsFailure(errorMsg));
      }
    };
  };
  